import React, { useState, useEffect } from "react";
import { SafeAreaView, Switch, ScrollView, StyleSheet, Text, Picker, View, TouchableOpacity, Modal, Pressable, ActivityIndicator } from 'react-native';
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as Animatable from 'react-native-animatable';
import Collapsible from 'react-native-collapsible';
import Accordion from 'react-native-collapsible/Accordion';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from '../assets/lang/i18next';

const BorodatiPro = (props) => {

  const { t, i18n } = useTranslation();
  const useStyles = makeStyles(() => ({
    textField: {
      width: "100%",
      marginTop: 20,
      marginLeft: "auto",
      marginRight: "auto",
      paddingBottom: 0,
      marginTop: 0,
      fontWeight: 500,
      fontSize: 13,
      direction: i18n.language == "en" ? "ltr" : "rtl",
      "& .MuiFormLabel-root": {
        color: "black",
        textAlign: i18n.language == "en" ? 'left' : 'right',
        fontFamily: 'IranSans',
        fontSize: 13, direction: i18n.language == "en" ? 'ltr' : 'rtl', width: '100%',
      },
      "& .MuiInputLabel-asterisk": {
        color: '#d12023',
        fontWeight: 900,
      },
      "& .MuiInputBase-input": {
        color: '#333', textAlign: 'center'
      },
      '& label.Mui-focused': {
        color: '#333',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'yellow',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'white',
        },
        '&:hover fieldset': {
          borderColor: '#06619b',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#333',
        },
      },

    },
    labelRoot: {
      right: i18n.language == "en" ? 0 : 20,
      left: i18n.language == "en" ? 20 : 0
    },
    shrink: {
      transformOrigin: i18n.language == "en" ? "top left" : "top right",
    },
    input: {
      color: "black", fontFamily: 'IranSans',
      fontSize: 13,

    },
  }));


  const SELECTORS = [
    { title: '-' },
    { title: t('productdata'), value: 4 },
    { title: t('otherheatsources'), value: 2 },
    { title: t('roominternaldimensions'), value: 1 },
    { title: t('generaldata'), value: 0 },
  ];
  let jamkol = 0;
  const [subtotal, Setsubtotal] = useState(0);
  const classes = useStyles();
  const [activeSections, setActiveSections] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [multipleSelect, setMultipleSelect] = useState(false);
  const [tempRoom, setTempRoom] = useState(0);
  const [tempOutRoom, setTempOutRoom] = useState(0);
  const [diffTempOutRoom, setDiffTempOutRoom] = useState(0);
  const [items, setItems] = useState([]);
  const [itemsdetail, setItemsDetail] = useState([]);
  const [selectedPrdtCatValue, setPrdtCatSelectedValue] = useState('');
  const [selectedPrdtValue, setPrdtSelectedValue] = useState('');
  const [selectlabelmahsol, setSelectLabelMahsol] = useState("");
  const [finaltmp, setFinalTmp] = useState('0');
  const [dbloadingcoefficient, setDbLoadingCoefficient] = useState('');
  const [dbrespirationheat, setDbRespirationheat] = useState('');
  const [dbtmpsolidification, setDbTmpSolidification] = useState('');
  const [dbheatcapbeforesolid, setDbHeatCapBeforeSolid] = useState(0);
  const [dbheatcapaftersolid, setDbHeatCapAfterSolid] = useState(0);
  const [dbspecialsolidofheat, setDbSpecialSolidofheat] = useState(0);
  const [dbdeltatcomp, setDbDeltatComp] = useState(0);
  const [data, setData] = useState(() => { item => setData(item) });
  const [datadetail, setDetailData] = useState(() => { item => setDetailData(item) });
  const [inprogsess, setInprogress] = useState(false);

  function getProductCategory() {
    fetch('https://app.arshehkar.com/query/public/GetProductCategroy.php')
      .then(response => response.json())
      .then(async (data) => {
        const mapArray = data.map(({ title_fa, id }) => ({ label: title_fa, value: id }));
        setItems(mapArray);
      })
  }
  function getProductCategoryEn() {
    fetch('https://app.arshehkar.com/query/public/GetProductCategroy.php')
      .then(response => response.json())
      .then(async (data) => {
        const mapArray = data.map(({ title_en, id }) => ({ label: title_en, value: id }));
        setItems(mapArray);
      })
  }

  const GetDetailPrdt = (idcatprdt) => {
    setInprogress(true);
    setItemsDetail([]);
    fetch(`https://app.arshehkar.com/query/public/GetDetailProduct.php?category=${idcatprdt}`)
      .then(response => response.json())
      .then(async (datadetail) => {
        const mapArrayDetail = datadetail.map(({ title_fa, id }) => ({ label: title_fa, value: id }));
        setItemsDetail(mapArrayDetail);

        if (datadetail.length > 0) {

          setPrdtSelectedValue(datadetail[0]['id']);
          setSelectLabelMahsol(datadetail[0]['title_fa']);
          GetFinalTemp(datadetail[0]['id']);


        }

        setInprogress(false);
      })
  }
  const GetDetailPrdtEn = (idcatprdt) => {
    setInprogress(true);
    setItemsDetail([]);
    fetch(`https://app.arshehkar.com/query/public/GetDetailProduct.php?category=${idcatprdt}`)
      .then(response => response.json())
      .then(async (datadetail) => {
        const mapArrayDetail = datadetail.map(({ title_en, id }) => ({ label: title_en, value: id }));
        setItemsDetail(mapArrayDetail);

        if (datadetail.length > 0) {

          setPrdtSelectedValue(datadetail[0]['id']);
          setSelectLabelMahsol(datadetail[0]['title_en']);
          GetFinalTemp(datadetail[0]['id']);


        }

        setInprogress(false);
      })
  }

  const GetFinalTemp = (idprdt) => {
    //  setInprogress(true);
    fetch(`https://app.arshehkar.com/query/public/GetFinalTmpByIdPrdt.php?id=${idprdt}`)
      .then(response => response.json())
      .then(async (responseJsontmp) => {
        setFinalTmp(responseJsontmp["finaltempture"]);
        setDbLoadingCoefficient(responseJsontmp["loadingcoefficient"]);
        setDbRespirationheat(responseJsontmp["respirationheat"]);
        setDbTmpSolidification(responseJsontmp["tmpsolidification"]);
        setDbHeatCapBeforeSolid(responseJsontmp["heatcapbeforesolid"]);
        setDbHeatCapAfterSolid(responseJsontmp["heatcapaftersolid"]);
        setDbSpecialSolidofheat(responseJsontmp["specialsolidofheat"]);
        setDbDeltatComp(responseJsontmp["deltatcomp"]);
        mohasebezarfiyatbargiripishnahadi(txt_tol, txt_arz, txt_ertefa, responseJsontmp["loadingcoefficient"]);
        //   setInprogress(false);
      })
  }
  const toggleExpanded = () => {
    setCollapsed(!collapsed);
  };
  const mohasebezarfiyatbargiripishnahadi = (paramtol, paramarz, paramertefa, paramzaribbargiri) => {
    if (paramzaribbargiri === "" || paramzaribbargiri == "-")
      setLblZarfiyatBargiriPishnahadi("-");
    else
      setLblZarfiyatBargiriPishnahadi(Math.round((paramtol * paramarz * paramertefa * 1000) / paramzaribbargiri));

  }
  const [isEnabled, setIsEnabled] = useState(false);
  const [isdefrostEnabled, setDefrostIsEnabled] = useState(false);
  const toggleSwitch = () => {
    setIsEnabled(previousState => !previousState);
  };
  const toggledefrostSwitch = () => {
    setDefrostIsEnabled(previousState => !previousState);
  };
  const [isTempHelpEnabled, setIsTempHelpEnabled] = useState(false);
  const toggleTempHelpSwitch = () => {
    setIsTempHelpEnabled(previousState => !previousState);
  };
  const [datacity, setCityData] = useState(() => { item => setCityData(item) });
  const [tempture, setTempture] = useState('0');
  const [itemsCityTemp, setCityTempItems] = useState([]);
  const [selectedCityValue, setCitySelectedValue] = useState('');
  const [selectedMonthValue, setMonthSelectedValue] = useState('');
  const [txt_final_tempture, setTxtFinalTempture] = useState('0');
  const [txt_damay_vorodi, setTxtDamayVorodi] = useState(0);
  const [txt_zaman_sardsazi, setTxtZamanSardsazi] = useState(0);
  const [txt_zarib_hedayat_hararati_ayegh, setTxtZaribHedayatHararatiAyegh] = useState('0.018');
  const [txt_zarib_hedayat_hararati_ayegh_kaf, setTxtZaribHedayatHararatiAyeghKaf] = useState('0.018');
  const [txtzekhamtayeghsaghfdivare, setTxtZekhamtAyeghSaghfDivare] = useState('');
  const [txtzekhamtayeghkaf, setTxtZekhamtAyeghKaf] = useState('');
  const [txt_tol, setTxtTol] = useState('0');
  const [txt_arz, setTxtArz] = useState('0');
  const [txt_ertefa, setTxtErtefa] = useState('0');
  const [txt_zarfiyat_bargiri, setTxtZarfiyatBargiri] = useState('0');
  const [txt_mizan_bargiri_rozane, setMizanBargiriRozane] = useState(0);
  const [lblzarfiyatbargiripishnahadi, setLblZarfiyatBargiriPishnahadi] = useState('0');
  const [txt_tavan_fanha, setTavanFanha] = useState(250);
  const [txt_saat_karkerd_tavan_fanha, setSaatKarkerdTavanFanha] = useState(20);
  const [txt_roshanaei, setTxtRoshanaei] = useState(15);
  const [txt_saat_karkerd_roshanaei, setSaatKarkerdRoshanaei] = useState(8);
  const [txt_tedad_kargar, setTxtTedadKargar] = useState(2);
  const [txt_saat_karkerd_tedad_kargar, setTxtSaatKarkerdTedadKargar] = useState(8);
  const [txt_lifterak, setTxtLiftrak] = useState(0);
  const [txt_saat_karkerd_liftrak, setTxtSaatKarkerdLiftrak] = useState(0);
  const [txt_tavan_element, setTxtTavanElement] = useState(1);
  const [txt_tedad_defrost, setTxtTedadDefrost] = useState(3);
  const [txt_zaman_defrost, setTxtZamanDefrost] = useState(15);
  const [txt_zaman_karkerd_system, setTxtZamanKarkerdSystem] = useState(0);
  const [selected_shedat_taviz_hava, setSelectedShedatTavizHava] = useState(1);
  const [anscalculate, setAnsCalculate] = useState('');
  const [errorlist, SetErrorList] = useState("");
  const [modalVisible, setModalVisible] = useState(false);



  const GetOutTemp = (city, month) => {
    //setInprogress(true);
    fetch(`https://app.arshehkar.com/query/public/GetTempByCityMonth.php?city=${city}`)
      .then(response => response.json())
      .then(async (responseJson) => {
        switch (month) {
          case '1':
            setTempture(responseJson["tmp_out_m_1"]);
            break;

          case '2':
            setTempture(responseJson["tmp_out_m_2"]);
            break;

          case '3':
            setTempture(responseJson["tmp_out_m_3"]);
            break;

          case '4':
            setTempture(responseJson["tmp_out_m_4"]);
            break;
          case '5':
            setTempture(responseJson["tmp_out_m_5"]);
            break;
          case '6':
            setTempture(responseJson["tmp_out_m_6"]);
            break;
          case '7':
            setTempture(responseJson["tmp_out_m_7"]);
            break;
          case '8':
            setTempture(responseJson["tmp_out_m_8"]);
            break;
          case '9':
            setTempture(responseJson["tmp_out_m_9"]);
            break;
          case '10':
            setTempture(responseJson["tmp_out_m_10"]);
            break;
          case '11':
            setTempture(responseJson["tmp_out_m_11"]);
            break;
          case '12':
            setTempture(responseJson["tmp_out_m_12"]);
            break;
          default:
            setTempture('خطا');

        }
        //  setInprogress(false);
      })
  }
  function getCities() {
    fetch('https://app.arshehkar.com/query/public/CityList.php')
      .then(response => response.json())
      .then(async (datacity) => {
        const mapArray = datacity.map(({ title_city, id }) => ({ label: title_city, value: id }));
        setCityTempItems(mapArray);
      })
  }
  function getCitiesEn() {
    fetch('https://app.arshehkar.com/query/public/CityList.php')
      .then(response => response.json())
      .then(async (datacity) => {
        const mapArray = datacity.map(({ title_en_city, id }) => ({ label: title_en_city, value: id }));
        setCityTempItems(mapArray);
      })
  }

  const CONTENT = [
    {
      title: t('generaldata'),
      content:
        <View style={{ flex: 1, width: '100%', backgroundColor: '#ebecec' }}>
          <TextField label={t('roomtemperature')}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            type="number"
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            onChange={event => { setTempRoom(event.target.value); setDiffTempOutRoom(tempOutRoom - event.target.value) }}
            value={tempRoom}
            onFocus={(e) => e.target.select()}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('outsidetemperature')}
            variant="filled"
            className={classes.textField}
            required
            type="number"
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            value={tempOutRoom}
            onChange={event => { setTempOutRoom(event.target.value); setDiffTempOutRoom(event.target.value - tempRoom) }}
            onFocus={(e) => e.target.select()}
            onWheel={(e) => e.target.blur()}
          />

          <Text style={{ fontFamily: 'IranSans', fontSize: 13, textAlign: 'center', fontWeight: 900, padding: 7, color: '#d12023' }}>
            {t('temperaturedifferencebetweeninsideandoutside')} : {diffTempOutRoom} {t('darajehc')}
          </Text>


          <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 7 }}>
            <Text style={{ fontFamily: 'IranSans', fontSize: 11, color: '#06619b' }} >{t('citytemperatureguide')}</Text>
            <Switch
              style={{ direction: 'ltr' }}
              trackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={isTempHelpEnabled ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggleTempHelpSwitch}
              value={isTempHelpEnabled}
            />
          </View>
          {isTempHelpEnabled === true ?
            <View>
              <Text style={styles.titleinput}>{t('citytemperature')}</Text>
              <Picker
                style={styles.picker}
                selectedValue={datacity}
                onValueChange={(itemValue, itemIndex) => {
                  setCitySelectedValue(itemValue);
                  GetOutTemp(itemValue, selectedMonthValue);
                }}
              >
                <Picker.Item label={t('select')} value="0" />
                {itemsCityTemp.map((item, index) => {
                  return (
                    <Picker.Item
                      key={index}
                      label={item.label}
                      value={item.value}
                    />
                  )
                }
                )
                }
              </Picker>
              <Text style={styles.titleinput}>{t('monthselect')}</Text>
              <Picker
                style={styles.picker}
                onValueChange={(itemValue, itemIndex) => {
                  setMonthSelectedValue(itemValue);
                  GetOutTemp(selectedCityValue, itemValue);
                }}

              >
                <Picker.Item label={t('select')} value="0" />
                <Picker.Item label={t('Month1')} value="1" />
                <Picker.Item label={t('Month2')} value="2" />
                <Picker.Item label={t('Month3')} value="3" />
                <Picker.Item label={t('Month4')} value="4" />
                <Picker.Item label={t('Month5')} value="5" />
                <Picker.Item label={t('Month6')} value="6" />
                <Picker.Item label={t('Month7')} value="7" />
                <Picker.Item label={t('Month8')} value="8" />
                <Picker.Item label={t('Month9')} value="9" />
                <Picker.Item label={t('Month10')} value="10" />
                <Picker.Item label={t('Month11')} value="11" />
                <Picker.Item label={t('Month12')} value="12" />
              </Picker>
              <Text style={{ fontFamily: 'IranSans', textAlign: 'center', fontSize: 13, fontWeight: 900, padding: 10, color: '#d12023' }}
                onPress={(e) => { setTempOutRoom(tempture); setDiffTempOutRoom(tempture - tempRoom) }}
              >
                {t('temperaturemaximum')} :  {tempture} {t('darajehc')}
              </Text>
            </View>
            : null}


          <Text style={styles.titleinput}>{t('ventilationlossfactor')}</Text>
          <Picker
            style={styles.picker}
            onValueChange={(itemValue, itemIndex) => {
              setSelectedShedatTavizHava(itemValue);
            }}
            selectedValue={selected_shedat_taviz_hava}
          >
            <Picker.Item value="0.5" label={t('light')} />
            <Picker.Item value="1" label={t('normal')} isActive={true} />
            <Picker.Item value="1.5" label={t('heavy')} />
          </Picker>
          <TextField label={t('runningtimeinstallation')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => setTxtZamanKarkerdSystem(e.target.value)}
            value={txt_zaman_karkerd_system}
            onWheel={(e) => e.target.blur()}
          />
        </View>
    },
    {
      title: t('roominternaldimensions'),
      content:
        <View style={{ flex: 1, width: '100%', backgroundColor: '#ebecec' }}>
          <TextField label={t('length')}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onFocus={(e) => e.target.select()}
            onChange={(e) => { setTxtTol(e.target.value); mohasebezarfiyatbargiripishnahadi(e.target.value, txt_arz, txt_ertefa, dbloadingcoefficient); }}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('width')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => { setTxtArz(e.target.value); mohasebezarfiyatbargiripishnahadi(txt_tol, e.target.value, txt_ertefa, dbloadingcoefficient); }}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('height')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => { setTxtErtefa(e.target.value); mohasebezarfiyatbargiripishnahadi(txt_tol, txt_arz, e.target.value, dbloadingcoefficient); }}
            onWheel={(e) => e.target.blur()}
          />


          <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
            <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
              <Text style={styles.titleinput}>{t('isolationmaterial')}</Text>
              <Picker style={styles.picker}
                onValueChange={(itemValue, itemIndex) => {
                  switch (itemValue) {
                    case '0':
                      setTxtZaribHedayatHararatiAyegh('0.018');
                      break;
                    case '1':
                      setTxtZaribHedayatHararatiAyegh('0.044');
                      break;
                    default:
                      setTxtZaribHedayatHararatiAyegh('0.018');
                  }
                }}
              >
                <Picker.Item value="0" label={t('polyurethane')} />
                <Picker.Item value="1" label={t('polystyrene')} />
              </Picker>
            </View>
            <View style={{ flex: 1, width: '50%' }}>
              <Text style={styles.titleinput}>{t('isolationthickness')}</Text>
              <TextField label={t('thickness')}
                onFocus={(e) => e.target.select()}
                variant="filled"
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtZekhamtAyeghSaghfDivare(e.target.value)}
                value={txtzekhamtayeghsaghfdivare}
                onWheel={(e) => e.target.blur()}
              />
            </View>
          </View>







          <Text style={{ fontFamily: 'IranSans', fontSize: 12.5, color: '#d12023', fontWeight: 900 }}>   {t('k-valueisolationpanel')} : W/m2K {txt_zarib_hedayat_hararati_ayegh}</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 15 }}>
            <Text style={{ fontFamily: 'IranSans', fontSize: 12.5, color: '#06619b' }} >{t('floorisolation')}</Text>
            <Switch
              style={{ direction: 'ltr' }}
              trackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={isEnabled ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggleSwitch}
              value={isEnabled}
            />
          </View>
          {isEnabled === true ?
            <View>


              <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
                <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
                  <Text style={styles.titleinput}>{t('floorisolationmaterial')}</Text>
                  <Picker style={styles.picker}
                    onValueChange={(itemValue, itemIndex) => {
                      switch (itemValue) {
                        case '0':
                          setTxtZaribHedayatHararatiAyeghKaf('0.018');
                          break;
                        case '1':
                          setTxtZaribHedayatHararatiAyeghKaf('0.044');
                          break;
                        default:
                          setTxtZaribHedayatHararatiAyeghKaf('0.018');
                      }
                    }}
                  >
                    <Picker.Item value="0" label={t('polyurethane')} />
                    <Picker.Item value="1" label={t('polystyrene')} />
                  </Picker>
                </View>
                <View style={{ flex: 1, width: '50%' }}>
                  <Text style={styles.titleinput}>{t('floorisolationthickness')}</Text>
                  <TextField label={t('thickness')}
                    onFocus={(e) => e.target.select()}
                    variant="filled"
                    className={classes.textField}
                    required
                    InputProps={{
                      className: classes.input
                    }}
                    InputLabelProps={{
                      classes: { root: classes.labelRoot, shrink: classes.shrink }
                    }}
                    margin="normal"
                    type="number"
                    onChange={(e) => setTxtZekhamtAyeghKaf(e.target.value)}
                    value={txtzekhamtayeghkaf}
                    onWheel={(e) => e.target.blur()}
                  />
                </View>
              </View>






              <Text style={{ fontFamily: 'IranSans', fontSize: 12.5, color: '#d12023', fontWeight: 900 }}> {t('k-valueisolationpanel')}  : W/m2K {txt_zarib_hedayat_hararati_ayegh_kaf}</Text>
            </View>
            : null}
        </View>,
    },
    {
      title: t('otherheatsources'),
      content:
        <View style={{ flex: 1, width: '100%', backgroundColor: '#ebecec' }}>

          <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
            <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
              <TextField label={t('fanspower')}
                onFocus={(e) => e.target.select()}
                variant="filled"
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTavanFanha(e.target.value)}
                placeholder={t('default250')}
                value={txt_tavan_fanha}
                onWheel={(e) => e.target.blur()}
              />
            </View>
            <View style={{ flex: 1, width: '50%' }}>
              <TextField label={t('workingtime')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setSaatKarkerdTavanFanha(e.target.value)}
                placeholder={t('default250')}
                value={txt_saat_karkerd_tavan_fanha}
                onWheel={(e) => e.target.blur()}
              />
            </View>
          </View>



          <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
            <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>

              <TextField label={t('illumination')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtRoshanaei(e.target.value)}
                placeholder={t('default15')}
                value={txt_roshanaei}
                onWheel={(e) => e.target.blur()}
              />
            </View>
            <View style={{ flex: 1, width: '50%' }}>
              <TextField label={t('workingtimeillumination')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setSaatKarkerdRoshanaei(e.target.value)}
                placeholder={t('default8')}
                value={txt_saat_karkerd_roshanaei}
                onWheel={(e) => e.target.blur()}
              />
            </View>
          </View>


          <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
            <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
              <TextField label={t('persons')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtTedadKargar(e.target.value)}
                placeholder={t('default2')}
                value={txt_tedad_kargar}
                onWheel={(e) => e.target.blur()}
              />
            </View>
            <View style={{ flex: 1, width: '50%' }}>
              <TextField label={t('workingtimeperson')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtSaatKarkerdTedadKargar(e.target.value)}
                placeholder={t('default2')}
                value={txt_saat_karkerd_tedad_kargar}
                onWheel={(e) => e.target.blur()}
              />
            </View>
          </View>




          <View style={{ flex: 1, flexDirection: "row", justifyContent: 'space-between', marginTop: 10 }}>
            <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
              <TextField label={t('forkliftsothers')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtLiftrak(e.target.value)}
                placeholder={t('default0')}
                value={txt_lifterak}
                onWheel={(e) => e.target.blur()}
              />
            </View>
            <View style={{ flex: 1, width: '50%' }}>
              <TextField label={t('workingtimeforklifts')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtSaatKarkerdLiftrak(e.target.value)}
                placeholder={t('default0')}
                value={txt_saat_karkerd_liftrak}
                onWheel={(e) => e.target.blur()}
              />
            </View>
          </View>






          <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 15 }}>

            <Text style={{ fontFamily: 'IranSans', fontSize: 12.5, color: '#06619b' }} >{t('electricdefrost')}</Text>
            <Switch
              style={{ direction: 'ltr' }}
              trackColor={{ false: "#767577", true: "#81b0ff" }}
              thumbColor={isdefrostEnabled ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggledefrostSwitch}
              value={isdefrostEnabled}
            />
          </View>
          {isdefrostEnabled === true ?
            <View>
              <TextField label={t('heaterspower')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtTavanElement(e.target.value)}
                value={txt_tavan_element}
                onWheel={(e) => e.target.blur()}

              />
              <TextField label={t('defrostperdar')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtTedadDefrost(e.target.value)}
                value={txt_tedad_defrost}
                onWheel={(e) => e.target.blur()}
              />
              <TextField label={t('defrosttime')}
                variant="filled"
                onFocus={(e) => e.target.select()}
                className={classes.textField}
                required
                InputProps={{
                  className: classes.input
                }}
                InputLabelProps={{
                  classes: { root: classes.labelRoot, shrink: classes.shrink }
                }}
                margin="normal"
                type="number"
                onChange={(e) => setTxtZamanDefrost(e.target.value)}
                value={txt_zaman_defrost}
                onWheel={(e) => e.target.blur()}
              />
            </View>
            : null
          }
        </View>
      ,
    },
    ,
    {
      title: t('productdata'),
      content:
        <View style={{ flex: 1, width: '100%', backgroundColor: '#ebecec' }}>
          <Text style={styles.titleinput}>{t('producttype')}</Text>
          <Picker
            style={styles.picker}
            selectedValue={data}
            onValueChange={(itemValue, itemIndex) => {
              setPrdtCatSelectedValue(itemValue);
              if (i18n.language == "en")
                GetDetailPrdtEn(itemValue);
              else
                GetDetailPrdt(itemValue);
            }}
          >
            <Picker.Item label={t('selectyurproducttype')} value="" />
            {items.map((item, index) => {
              return (
                <Picker.Item
                  key={index}
                  label={item.label}
                  value={item.value}
                />
              )
            }
            )
            }
          </Picker>
          <Picker
            style={styles.picker}

            onValueChange={(itemValue, itemIndex) => {
              setPrdtSelectedValue(itemValue);
              setSelectLabelMahsol(itemsdetail[itemIndex].label);
              GetFinalTemp(itemValue);
            }}

          >

            {itemsdetail.map((item, index) => {
              return (
                <Picker.Item
                  key={index}
                  label={item.label}
                  value={item.value}
                />
              )
            }
            )
            }
          </Picker>
          <TextField label={t('storagequantity')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            value={txt_zarfiyat_bargiri}
            onChange={(e) => {
              setTxtZarfiyatBargiri(e.target.value);
              if (e.target.value < 150000)
                setMizanBargiriRozane(Math.round(e.target.value * 0.1));
              else if (e.target.value >= 150000 && e.target.value < 250000)
                setMizanBargiriRozane("15000");
              else if (e.target.value >= 250000 && e.target.value < 350000)
                setMizanBargiriRozane("17500");
              else if (e.target.value >= 350000 && e.target.value < 450000)
                setMizanBargiriRozane("20000");
              else if (e.target.value >= 450000 && e.target.value < 550000)
                setMizanBargiriRozane("25000");
              else if (e.target.value >= 550000)
                setMizanBargiriRozane(Math.round(e.target.value * 0.05));
            }}
            type="number"
            onWheel={(e) => e.target.blur()}
          />
          <Text onPress={() => {
            setTxtZarfiyatBargiri(lblzarfiyatbargiripishnahadi);
            if (lblzarfiyatbargiripishnahadi < 150000)
              setMizanBargiriRozane(Math.round(lblzarfiyatbargiripishnahadi * 0.1));
            else if (lblzarfiyatbargiripishnahadi >= 150000 && lblzarfiyatbargiripishnahadi < 250000)
              setMizanBargiriRozane(15000);
            else if (lblzarfiyatbargiripishnahadi >= 250000 && lblzarfiyatbargiripishnahadi < 350000)
              setMizanBargiriRozane(17500);
            else if (lblzarfiyatbargiripishnahadi >= 350000 && lblzarfiyatbargiripishnahadi < 450000)
              setMizanBargiriRozane(20000);
            else if (lblzarfiyatbargiripishnahadi >= 450000 && lblzarfiyatbargiripishnahadi < 550000)
              setMizanBargiriRozane(25000);
            else if (lblzarfiyatbargiripishnahadi >= 550000)
              setMizanBargiriRozane(Math.round(lblzarfiyatbargiripishnahadi * 0.05));
          }}
            style={{ fontFamily: 'IranSans', textAlign: 'center', fontSize: 13, fontWeight: 900, padding: 7, color: '#d12023' }}>
            {t('recommended')} : {lblzarfiyatbargiripishnahadi} {t('kg')}
          </Text>
          <TextField label={t('stockshift')}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            type="number"
            margin="normal"
            value={txt_mizan_bargiri_rozane}
            onChange={(e) => setMizanBargiriRozane(e.target.value)}
            onFocus={(e) => e.target.select()}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('enteringtemperature')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => setTxtDamayVorodi(e.target.value)}
            value={txt_damay_vorodi}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('cooldowncongelationtime')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => setTxtZamanSardsazi(e.target.value)}
            value={txt_zaman_sardsazi}
            onWheel={(e) => e.target.blur()}
          />
          <TextField label={t('finaltemperature')}
            onFocus={(e) => e.target.select()}
            variant="filled"
            className={classes.textField}
            required
            InputProps={{
              className: classes.input
            }}
            InputLabelProps={{
              classes: { root: classes.labelRoot, shrink: classes.shrink }
            }}
            margin="normal"
            type="number"
            onChange={(e) => setTxtFinalTempture(e.target.value)}
            value={txt_final_tempture}
            onWheel={(e) => e.target.blur()}
          />
          <Text style={{ fontFamily: 'IranSans', textAlign: 'center', fontSize: 13, fontWeight: 900, padding: 7, color: '#d12023' }}
            onPress={() => setTxtFinalTempture(finaltmp)} >
            {t('recommended')} : {finaltmp} {t('darajehc')}
          </Text>
        </View>,
    },
  ];
  const setSections = (sections) => {
    setActiveSections(sections.includes(undefined) ? [] : sections);
  };

  const renderHeader = (section, _, isActive) => {
    return (
      <Animatable.View
        duration={400}
        style={[styles.header, isActive ? styles.active : styles.inactive]}
        transition="backgroundColor">
        <Text style={[styles.headerText, { textAlign: i18n.language == "en" ? 'left' : 'right' }]}>{section.title}</Text>
      </Animatable.View>
    );
  };

  const renderContent = (section, _, isActive) => {
    return (
      <Animatable.View
        duration={400}
        style={[styles.content, isActive ? styles.active : styles.inactive]}
        transition="backgroundColor">
        <Animatable.Text
          animation={isActive ? 'bounceIn' : undefined}
          style={{ textAlign: 'center' }}>
          {section.content}
        </Animatable.Text>
      </Animatable.View>
    );
  };


  let jedareha = 0, sardsazi = 0, tavizhava = 0, hararatyi = 0, tanafosi = 0, qtransfer = 0, tctransfer = 0, tetransfer = 0;
  const [q, setQ] = useState(0);
  const [tc, SetTc] = useState(0);

  const FunSetansbarjedareha = () => {

    jedareha = (isEnabled === true) ?
      (((((txt_zarib_hedayat_hararati_ayegh * 1000) / parseFloat(txtzekhamtayeghsaghfdivare)) * ((txt_tol * txt_ertefa * 2) + (txt_tol * txt_arz) + (txt_ertefa * txt_arz * 2)) * (parseFloat(tempOutRoom) - parseFloat(tempRoom))) / 1000)
        +
        ((((txt_zarib_hedayat_hararati_ayegh_kaf * 1000) / parseFloat(txtzekhamtayeghkaf)) * (txt_tol * txt_arz) * (parseFloat(tempOutRoom) <= 0 ? ((parseFloat(27.0373) + ((parseFloat(0.3955711) * parseFloat(tempRoom))) - (parseFloat(0.01156177) * (Math.pow(tempRoom, 2))) - (parseFloat(0.0004475524) * (Math.pow(tempRoom, 3))) - (parseFloat(0.000005594406) * (Math.pow(tempRoom, 4)))) - parseFloat(tempRoom)) : (parseFloat(tempOutRoom) - parseFloat(tempRoom)))) / 1000)).toFixed(3)
      :
      (((2.25 * (txt_tol * txt_arz) * ((parseFloat(tempOutRoom) <= 0 ? ((parseFloat(27.0373) + ((parseFloat(0.3955711) * parseFloat(tempRoom))) - (parseFloat(0.01156177) * (Math.pow(tempRoom, 2))) - (parseFloat(0.0004475524) * (Math.pow(tempRoom, 3))) - (parseFloat(0.000005594406) * (Math.pow(tempRoom, 4)))) - parseFloat(tempRoom)) : (parseFloat(tempOutRoom) - parseFloat(tempRoom))))) / 1000)
        +
        ((((txt_zarib_hedayat_hararati_ayegh * 1000) / parseFloat(txtzekhamtayeghsaghfdivare)) * ((txt_tol * txt_ertefa * 2) + (txt_tol * txt_arz) + (txt_ertefa * txt_arz * 2)) * (parseFloat(tempOutRoom) - parseFloat(tempRoom))) / 1000)).toFixed(3);

    if (jedareha != "خطا" && jedareha != "")
      jamkol = parseFloat(jamkol) + parseFloat(jedareha);



    sardsazi = (parseFloat(txt_final_tempture) >= parseFloat(dbtmpsolidification)) ?
      (((txt_mizan_bargiri_rozane * dbheatcapbeforesolid * (txt_damay_vorodi - (parseFloat(txt_final_tempture) > parseFloat(dbtmpsolidification) ? txt_final_tempture : dbtmpsolidification))) / (3600 * txt_zaman_sardsazi))).toFixed(3)
      :
      ((parseFloat(dbtmpsolidification) > parseFloat(txt_final_tempture)) && (parseFloat(txt_damay_vorodi) > parseFloat(dbtmpsolidification))) ?
        ((((txt_mizan_bargiri_rozane * dbspecialsolidofheat) / (3600 * txt_zaman_sardsazi)) +
          ((txt_mizan_bargiri_rozane * dbheatcapbeforesolid * (txt_damay_vorodi - (parseFloat(txt_final_tempture) > parseFloat(dbtmpsolidification) ? txt_final_tempture : dbtmpsolidification))) / (3600 * txt_zaman_sardsazi))
          + ((txt_mizan_bargiri_rozane * dbheatcapaftersolid * ((parseFloat(dbtmpsolidification) > parseFloat(txt_damay_vorodi) && parseFloat(dbtmpsolidification) > parseFloat(txt_final_tempture) ? txt_damay_vorodi : dbtmpsolidification) - txt_final_tempture)) / (3600 * txt_zaman_sardsazi))
        )).toFixed(3)
        :
        ((parseFloat(dbtmpsolidification) > parseFloat(txt_final_tempture)) && (parseFloat(dbtmpsolidification) >= parseFloat(txt_damay_vorodi))) ?
          (
            (((txt_mizan_bargiri_rozane * dbheatcapaftersolid * ((((parseFloat(dbtmpsolidification) > parseFloat(txt_damay_vorodi)) && (parseFloat(dbtmpsolidification) > parseFloat(txt_final_tempture))) ? txt_damay_vorodi : dbtmpsolidification) - txt_final_tempture)) / (3600 * txt_zaman_sardsazi))).toFixed(3)
          )
          : (dbtmpsolidification == "" || dbtmpsolidification == null) ?
            (((txt_mizan_bargiri_rozane * dbheatcapbeforesolid * (txt_damay_vorodi - (parseFloat(txt_final_tempture) > parseFloat(dbtmpsolidification) ? txt_final_tempture : dbtmpsolidification))) / (3600 * txt_zaman_sardsazi))).toFixed(3)
            :
            "خطا";
    if (sardsazi != "خطا" && sardsazi != "")
      jamkol = parseFloat(jamkol) + parseFloat(sardsazi);



    tavizhava = (txt_tol * txt_arz * txt_ertefa <= 100) ?
      ((((0.7 * (txt_tol * txt_arz * txt_ertefa) + 2) * (tempOutRoom - tempRoom)) / 1000) * selected_shedat_taviz_hava)
      :
      (txt_tol * txt_arz * txt_ertefa > 100 && txt_tol * txt_arz * txt_ertefa < 1000) ?
        ((((0.125 * (txt_tol * txt_arz * txt_ertefa) + 27) * (tempOutRoom - tempRoom)) / 1000) * selected_shedat_taviz_hava)
        :
        (txt_tol * txt_arz * txt_ertefa >= 1000) ?
          ((((0.04 * (txt_tol * txt_arz * txt_ertefa) + 78) * (tempOutRoom - tempRoom)) / 1000) * selected_shedat_taviz_hava)
          :
          'خطا';
    if (tavizhava != "خطا" && tavizhava != "")
      jamkol = parseFloat(jamkol) + parseFloat(tavizhava);




    hararatyi = (isdefrostEnabled === true) ?
      (
        (
          (
            (
              ((txt_tavan_fanha * txt_saat_karkerd_tavan_fanha) / 24)
              +
              ((txt_roshanaei * txt_saat_karkerd_roshanaei * txt_tol * txt_arz) / 24)
              +
              ((((0.2736364 - 0.006514719 * parseFloat(tempRoom) + (0.00006030303 * (Math.pow(tempRoom, 2))) - (0.000001454545 * (Math.pow(tempRoom, 3))) - 0.0000002060606 * (Math.pow(tempRoom, 4))) * txt_tedad_kargar * txt_saat_karkerd_tedad_kargar) / 24) * 1000)
              +
              ((txt_lifterak * txt_saat_karkerd_liftrak) / 24)
            )
            +
            (
              (((txt_tavan_element * txt_tedad_defrost * txt_zaman_defrost) / txt_zaman_karkerd_system) *
                (
                  ((0.5 * (35.10315 + (1.466078 * tempRoom) + 0.2219784 * Math.pow(tempRoom, 2) + 0.01979662 * Math.pow(tempRoom, 3) + 0.0006481352 * Math.pow(tempRoom, 4) + 0.000007025641 * Math.pow(tempRoom, 5) - 36.14136 + 1.279861 * (txt_zaman_defrost * txt_tedad_defrost) - 0.005317509 * Math.pow((txt_zaman_defrost * txt_tedad_defrost), 2) + 0.00001004546 * Math.pow((txt_zaman_defrost * txt_tedad_defrost), 3) - 0.000000007051621 * Math.pow((txt_zaman_defrost * txt_tedad_defrost), 4)))
                  ).toFixed(2)
                )) / 1000)

          ) / 1000
        )).toFixed(3)
      :
      (
        (
          (
            ((txt_tavan_fanha * txt_saat_karkerd_tavan_fanha) / 24)
            +
            ((txt_roshanaei * txt_saat_karkerd_roshanaei * txt_tol * txt_arz) / 24)
            +
            ((((0.2736364 - 0.006514719 * parseFloat(tempRoom) + (0.00006030303 * (Math.pow(tempRoom, 2))) - (0.000001454545 * (Math.pow(tempRoom, 3))) - 0.0000002060606 * (Math.pow(tempRoom, 4))) * txt_tedad_kargar * txt_saat_karkerd_tedad_kargar) / 24) * 1000)
            +
            ((txt_lifterak * txt_saat_karkerd_liftrak) / 24)
          )
          / 1000)).toFixed(3);

    if (hararatyi != "خطا" && hararatyi != "")
      jamkol = parseFloat(jamkol) + parseFloat(hararatyi);



    tanafosi = (parseFloat(txt_final_tempture) <= parseFloat(dbtmpsolidification)) ? "0" :
      ((txt_zarfiyat_bargiri * dbrespirationheat) / (txt_zaman_sardsazi * 3600)).toFixed(3);
    if (tanafosi != "خطا" && tanafosi != "")
      jamkol = parseFloat(jamkol) + parseFloat(tanafosi);


    qtransfer = ((jamkol * 24) / txt_zaman_karkerd_system).toFixed(2);
    setQ(qtransfer);
    tctransfer = Math.floor(parseFloat(tempOutRoom) + ((parseFloat(-0.24) * parseFloat(tempOutRoom)) + 19));
    SetTc(tctransfer);
    tetransfer = ((parseFloat(tempRoom) - parseFloat(dbdeltatcomp)) < parseFloat("-45") && (parseFloat(tempRoom) - parseFloat(dbdeltatcomp)) > parseFloat("-48")) ? "-45" : (parseFloat(tempRoom) - parseFloat(dbdeltatcomp));
    //SetTe(tetransfer);



  }


  React.useEffect(() => {




    if (i18n.language == "en") {
      getProductCategoryEn();
      getCitiesEn();
    }
    else {
      getProductCategory();
      getCities();
    }
  }, [i18n.language]);


  return (


    <ScrollView style={{ backgroundColor: '#ebecec' }}>
      <View style={styles.container}>
        {inprogsess === true ?
          <View style={styles.spinner}>
            <ActivityIndicator size={90} color='#d12023' />
          </View>
          : null}

        <Text style={{ fontFamily: 'IranSans', color: '#000', fontWeight: 600, textAlign: 'center', margin: 10, fontSize: 14 }}>{t('coldroomcalculation(advanced)')}</Text>
        <View style={styles.centeredView}>
          <Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
              Alert.alert("Modal has been closed.");
              setModalVisible(!modalVisible);
            }}
          >
            <View style={styles.centeredView}>

              <View style={styles.modalView}>
                <View style={[{ flexDirection: 'row', alignItems: 'center' }]}>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderBottomColor: '#d12023',
                      width: 100, flex: 1, height: 2
                    }}
                  />
                  <View>
                    <Text style={[styles.textStyle, { width: 50, textAlign: 'center', color: "#000" }]}>{t('error')}</Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderBottomColor: '#d12023',
                      width: 100, flex: 1, height: 2
                    }}
                  />
                </View>
                <Text style={styles.modalText}>{errorlist}</Text>
                <TouchableOpacity
                  style={[styles.button, styles.buttonClose]}
                  onPress={() => setModalVisible(!modalVisible)}
                >
                  <Text style={styles.textStyle}> {t('ok')} </Text>
                </TouchableOpacity>
              </View>
            </View>
          </Modal>
        </View>
        <View style={styles.form}>
          <View style={[styles.selectors, { flexDirection: i18n.language == "en" ? 'row-reverse' : 'row' }]}>
            {SELECTORS.map((selector) => (
              <TouchableOpacity
                key={selector.title}
                onPress={() => setSections([selector.value])}
              >
                <View style={styles.selector}>
                  <Text
                    style={
                      [activeSections.includes(selector.value) &&
                        styles.activeSelector, { fontFamily: 'IranSans', fontSize: 13, fontWeight: 500 }]
                    }>
                    {selector.title}
                  </Text>
                </View>
              </TouchableOpacity>
            ))}
          </View>
          <Accordion
            activeSections={activeSections}
            sections={CONTENT}
            touchableComponent={TouchableOpacity}
            expandMultiple={multipleSelect}
            renderHeader={renderHeader}
            renderContent={renderContent}
            duration={400}
            onChange={setSections}
          />





          <TouchableOpacity style={styles.touchable}
            onPress={() => {
              let MSGERROR = "";

              if (parseFloat(tempRoom) < parseFloat("-50") || parseFloat(tempRoom) > parseFloat("20"))
                MSGERROR += t('Theroomtemperatureshouldbebetween-50and20degreesCelsius') + "\n";
              if (parseFloat(tempOutRoom) < parseFloat("-20") || parseFloat(tempOutRoom) > parseFloat("60"))
                MSGERROR += t('Theoutsidetemperatureshouldbebetween-20and60degreesCelsius') + "\n";
              if (parseFloat(tempOutRoom) < parseFloat(tempRoom))
                MSGERROR += t('Theoutsidetemperatureshouldnotbelowerthantheroomtemperature') + "\n";
              if (parseFloat(txt_zaman_karkerd_system) < 0 || parseFloat(txt_zaman_karkerd_system) > 24)
                MSGERROR += t('runningtimeinstallationshouldbebetween0and24hours') + "\n";
              if (parseFloat(txt_zaman_sardsazi) < 0 || parseFloat(txt_zaman_sardsazi) > 24)
                MSGERROR += t('Thecoolingtimeshouldbebetween0and24hours') + "\n";
              if (isdefrostEnabled === true) {
                if (parseFloat(txt_zaman_defrost) < 0 || parseFloat(txt_zaman_defrost) > 60)
                  MSGERROR += t('Defrosttimemustbebetween0and60minutes') + "\n";
              }
              if (parseFloat(txt_tol) <= 0 || parseFloat(txt_arz) <= 0 || parseFloat(txt_ertefa) <= 0)
                MSGERROR += t('Dimensions(length,width,height)mustbegreaterthan0') + "\n";
              if (parseFloat(txtzekhamtayeghsaghfdivare) < 10 || parseFloat(txtzekhamtayeghsaghfdivare) > 250)
                MSGERROR += t('Thethicknessofthewallmustbebetween10and250mm') + "\n";
              if (parseFloat(txtzekhamtayeghkaf) < 10 || parseFloat(txtzekhamtayeghkaf) > 250)
                MSGERROR += t('Thethicknessofthefloormustbebetween10and250mm') + "\n";
              if (parseFloat(txt_damay_vorodi) < parseFloat("-50"))
                MSGERROR += t('enteringtemperaturemustbeanumbergreaterthan50Celsius') + "\n";
              if (parseFloat(txt_final_tempture) < parseFloat("-50") || parseFloat(txt_final_tempture) > 50)
                MSGERROR += t('Thefinaltemperatureshouldbeanumberbetween50and50degreesCelsius') + "\n";
              if (parseFloat(txt_final_tempture) > parseFloat(txt_damay_vorodi))
                MSGERROR += t('Thefinaltemperatureshouldnotbehigherthantheinlettemperature') + "\n";
              if (parseFloat(txt_final_tempture) < parseFloat(tempRoom))
                MSGERROR += t('Thefinaltemperatureshouldnotbelowerthanroomtemperature') + "\n";
              if (parseFloat(txt_saat_karkerd_tavan_fanha) < 0 || parseFloat(txt_saat_karkerd_tavan_fanha) > 24)
                MSGERROR += t('Theoperatingtimeofthefansshouldbebetween0and24hours') + "\n";
              if (parseFloat(txt_saat_karkerd_roshanaei) < 0 || parseFloat(txt_saat_karkerd_roshanaei) > 24)
                MSGERROR += t('Lightingoperationtimeshouldbebetween0and24hours') + "\n";
              if (parseFloat(txt_saat_karkerd_tedad_kargar) < 0 || parseFloat(txt_saat_karkerd_tedad_kargar) > 24)
                MSGERROR += t('Theworkingtimeofthenumberofworkersmustbebetween0and24hours') + "\n";
              if (parseFloat(txt_saat_karkerd_liftrak) < 0 || parseFloat(txt_saat_karkerd_liftrak) > 24)
                MSGERROR += t('Forkliftoperatingtimeshouldbebetween0and24hours') + "\n";



              if (tempRoom === "")
                MSGERROR += t('Enterroomtemperature') + "\n";
              if (tempOutRoom == "")
                MSGERROR += t('Entertheoutsidetemperature') + "\n";
              if (txt_zaman_karkerd_system == "")
                MSGERROR += t('Entertherunningtimeofthesystem') + "\n";
              if (txt_tol == "")
                MSGERROR += t('enterlength') + "\n";
              if (txt_arz == "")
                MSGERROR += t('Enterwidth') + "\n";
              if (txt_ertefa == "")
                MSGERROR += t('Entertheheight') + "\n";
              if (txtzekhamtayeghsaghfdivare == "")
                MSGERROR += t('Enterthethicknessoftheroofandwallinsulation') + "\n";
              if (txt_tavan_fanha == "")
                MSGERROR += t('Enterthepowerofthefans') + "\n";
              if (txt_saat_karkerd_tavan_fanha == "")
                MSGERROR += t('Entertheoperatinghoursofthefanpower') + "\n";
              if (txt_roshanaei == "")
                MSGERROR += t('EntertheLightingenergyconsumption') + "\n";
              if (txt_saat_karkerd_roshanaei == "")
                MSGERROR += t('Entertheoperatinghoursofthelighting') + "\n";
              if (txt_tedad_kargar == "")
                MSGERROR += t('Enterthenumberofworkers') + "\n";
              if (txt_saat_karkerd_tedad_kargar == "")
                MSGERROR += t('Entertheworkinghoursoftheworkers') + "\n";
              if (txt_lifterak == "" && txt_lifterak != "0")
                MSGERROR += t('Entertheforkliftpower') + "\n";
              if (txt_saat_karkerd_liftrak == "" && txt_saat_karkerd_liftrak != "0")
                MSGERROR += t('Entertheworkinghoursoftheforklift') + "\n";
              if (txt_zarfiyat_bargiri == "")
                MSGERROR += t('Entertotalstoragequantity') + "\n";
              if (txt_mizan_bargiri_rozane == "")
                MSGERROR += t('Entertheamountofstockshift') + "\n";
              if (txt_damay_vorodi == "")
                MSGERROR += t('entertheenteringtemperature') + "\n";
              if (txt_zaman_sardsazi == "")
                MSGERROR += t('Entercoolingtime') + "\n";
              if (txt_final_tempture == "")
                MSGERROR += t('Enterfinaltemperature') + "\n";
              if (selectedPrdtCatValue == "" || selectedPrdtValue == "")
                MSGERROR += t('Choosethedesiredproduct') + "\n";








              if (MSGERROR === "") {
                FunSetansbarjedareha();
                props.navigation.navigate('BorodatiResult', {
                  DAMAYOTAGH: tempRoom, DAMAYOUT: tempOutRoom, SHEDAT: selected_shedat_taviz_hava, ZAMANSYSTEM: txt_zaman_karkerd_system, TOL: txt_tol, ARZ: txt_arz, ERTEFA: txt_ertefa, AYEGH: txt_zarib_hedayat_hararati_ayegh, ZEKHAMATDIVAR: txtzekhamtayeghsaghfdivare, ZEKHAMATKAF: txtzekhamtayeghkaf, ZARIBHADAYATAYEGH: txt_zarib_hedayat_hararati_ayegh, TAVANFAN: txt_tavan_fanha + "/" + txt_saat_karkerd_tavan_fanha, ROSHANAIE: txt_roshanaei + "/" + txt_saat_karkerd_roshanaei, TEDADKARGAR: txt_tedad_kargar + "/" + txt_saat_karkerd_tedad_kargar, LIFTRAG: txt_lifterak + "/" + txt_saat_karkerd_liftrak, ZARFIYATBARGIRI: txt_zarfiyat_bargiri, ZARFIYATBARGIRIROZANEH: txt_mizan_bargiri_rozane, DAMAYVORODI: txt_damay_vorodi, ZAMANSARDSAZI: txt_zaman_sardsazi, KARBARI: selectlabelmahsol
                  , TALAFATJEDAREHA: jedareha, TALAFATHAVA: tavizhava, MABAGHIHARARATI: hararatyi,
                  BARSARDSAZI: sardsazi, BARTANAFOSI: tanafosi, QN: qtransfer, TE: tetransfer, TC: tctransfer
                })
              }
              else {
                SetErrorList(MSGERROR);
                setModalVisible(true);
              };

            }}>
            <Text style={styles.titlebutton}>{t('calculatecoolingload')}</Text>
            <Icon name={"calculator"} color="#fff" size={20} />
          </TouchableOpacity>



        </View>


      </View>
    </ScrollView>




  )
}

export default BorodatiPro;
const styles = StyleSheet.create({
  touchable: {
    backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4, flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  container: {
    alignItems: 'center',
    backgroundColor: '#ebecec'
  },
  form: {
    width: '100%',
    backgroundColor: '#ebecec',
    margin: 5,
    padding: 5,
    justifyContent: 'center',
    alignItems: 'stretch',

  },
  title: {
    textAlign: 'center',
    fontSize: 13,
    fontWeight: '300',
    marginBottom: 10,

  },
  header: {
    padding: 7,
  },
  headerText: {
    fontSize: 13.7,
    fontWeight: '900', backgroundColor: '#78909C', color: '#000', padding: 12, fontFamily: 'IranSans', shadowColor: '#000',
    shadowOffset: { width: 1, height: 0.5 },
    shadowOpacity: 0.7,
    shadowRadius: 3, fontFamily: 'IranSans'
  },
  content: {
    padding: 15,
    backgroundColor: '#ebecec',
  },
  active: {
    backgroundColor: '#ebecec',
  },
  inactive: {
    backgroundColor: '#e6e6e6',
  },
  selectors: {
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#06619b', fontFamily: 'IranSans', fontSize: 13, shadowColor: '#000',
    shadowOffset: { width: 1, height: 0.5 },
    shadowOpacity: 0.7,
    shadowRadius: 3,
  },
  selector: {
    fontFamily: 'IranSans',
    padding: 10,
  },
  activeSelector: {
    fontWeight: 'bold',
    fontFamily: 'IranSans',
    fontSize: 13, color: '#78909C',
  },
  selectTitle: {
    fontSize: 13,
    fontWeight: '500',
    padding: 10,
    textAlign: 'center',
    fontFamily: 'IranSans'
  },
  multipleToggle: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginVertical: 30,
    alignItems: 'center',
  },
  multipleToggle__title: {
    fontSize: 13,
    marginRight: 8,
    fontFamily: 'IranSans',
  },
  titlepage: {
    fontSize: 13,
    fontWeight: '800',
    fontFamily: 'IranSans',
    marginBottom: 25,
  }
  ,
  titleinput: {
    fontFamily: 'IranSans',
    fontSize: 13,
    textAlign: 'right',
  }
  ,
  textinput: {
    padding: 5,
    fontFamily: 'IranSans',
    fontSize: 13,
    textAlign: 'center',
    borderBottomColor: '#e6e6e6',
    borderWidth: 1,

  }
  ,
  picker: {
    height: 50,
    width: '100%',
    marginBottom: 10,
    fontFamily: 'IranSans',
    fontSize: 13,
    borderWidth: 0,
    textAlign: 'center',
    backgroundColor: '#c9c9c9',
    direction: 'rtl',
  },
  titlebutton: {

    fontSize: 14,
    lineHeight: 21,
    fontWeight: 'normal',
    fontFamily: 'IranSans',
    letterSpacing: 0.25,
    color: 'white',
    textAlign: 'center', marginRight: 20,

  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10
  },
  modalView: {
    margin: 10,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 15,
    width: '75%',
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2
  },
  buttonOpen: {
    backgroundColor: "#F194FF",
  },
  buttonClose: {
    backgroundColor: "#06619b",
  },
  textStyle: {
    color: "white",
    fontWeight: 600,
    textAlign: "center",
    fontFamily: 'IranSans',
    fontSize: 14.1

  },
  modalText: {
    marginBottom: 10,
    textAlign: "center", fontFamily: 'IranSans', fontSize: 13.5,
  },
  spinner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'black',
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9000,
    opacity: 0.5,
  }
});